require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).ChevronLeft = e.ChevronLeft || {}, e.ChevronLeft.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function n(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var a = n(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function f() {
    return f = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, f.apply(this, arguments);
  }

  function u(e, r) {
    if (null == e) return {};

    var t,
        l,
        n = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          n = {},
          a = Object.keys(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || (n[t] = e[t]);
      }

      return n;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        n = e.size,
        i = void 0 === n ? 16 : n,
        y = e.title,
        v = e["aria-label"],
        g = e["aria-labelledby"],
        m = e.fill,
        h = e.role,
        O = void 0 === h ? "img" : h,
        j = u(e, d),
        L = t.css(s || (s = c(["\n    color: ", ";\n  "])), m),
        C = t.css(b || (b = c(["\n    flex-shrink: 0;\n  "]))),
        w = function (e, r, t) {
      var l,
          n,
          a = t["aria-label"],
          i = t["aria-labelledby"],
          f = t.title;

      switch (e) {
        case "img":
          return a || i || f ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", a), o(l, "title", f), l) : {
            "aria-label": (n = r, "".concat(n.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(O, "ChevronLeft", (o(r = {
      title: y
    }, "aria-label", v), o(r, "aria-labelledby", g), r));

    return a.createElement("svg", f({
      className: t.cx(o({}, L, null != m), C, l),
      height: "number" == typeof i ? i : p[i],
      width: "number" == typeof i ? i : p[i],
      role: O
    }, w, j, {
      viewBox: "0 0 16 16"
    }), a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7782 1.63604C10.3877 1.24551 9.75449 1.24551 9.36396 1.63604L4.41421 6.58579L3.70711 7.29289C3.31658 7.68342 3.31658 8.31658 3.70711 8.70711L4.41421 9.41421L9.36396 14.364C9.75448 14.7545 10.3876 14.7545 10.7782 14.364L11.4853 13.6569C11.8758 13.2663 11.8758 12.6332 11.4853 12.2426L7.24264 8L11.4853 3.75736C11.8758 3.36684 11.8758 2.73367 11.4853 2.34315L10.7782 1.63604Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "ChevronLeft", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});